(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  function updateQty(index, change) {
    const inputs = document.querySelectorAll('input[name="updates[]"]');
    const input = inputs[index];
    const newValue = parseInt(input.value) + change;
    if (newValue >= 0) {
      input.value = newValue;
    }
  }
  
  document.addEventListener('DOMContentLoaded', function() {
    const form = document.getElementById('cart-form');
    if (form) {
      const updateBtn = form.querySelector('button[name="update"]');
      if (updateBtn) {
        updateBtn.addEventListener('click', function(e) {
          e.preventDefault();
          form.submit();
        });
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  (function() {
    var btn = document.getElementById('tw-back-to-top');
    if (btn) {
      function toggle() { btn.classList.toggle('tw-opacity-100', window.scrollY > 400); btn.classList.toggle('tw-pointer-events-auto', window.scrollY > 400); }
      window.addEventListener('scroll', toggle);
      toggle();
      btn.addEventListener('click', function(e) { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); });
    }

    // Pestañas / Acordeón Footer Mobile
    document.querySelectorAll('.tw-footer__heading').forEach(function(heading) {
      heading.addEventListener('click', function() {
        if (window.innerWidth < 768) {
          var block = this.closest('.tw-footer__block');
          var isActive = block.classList.contains('is-active');
          
          if (!isActive) {
            block.classList.add('is-active');
          } else {
            block.classList.remove('is-active');
          }
        }
      });
    });

    document.querySelectorAll('#FooterCountryForm select[data-submit], #FooterLanguageForm select[data-submit]').forEach(function(el) {
      el.addEventListener('change', function() { this.form.submit(); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid-simple"] && !Shopify.designMode) return;
  try {
    
    (() => {
      const toBool = (v) => String(v) === 'true' || String(v) === '1';

      function initSwiper(sectionRoot) {
        const el = sectionRoot.querySelector('[data-pgs-swiper]');
        if (!el || !window.Swiper) return false;

        if (el.__pgsSwiper) {
          try { el.__pgsSwiper.destroy(true, true); } catch(e) {}
          el.__pgsSwiper = null;
        }

        const prev = sectionRoot.querySelector('[data-pgs-prev]');
        const next = sectionRoot.querySelector('[data-pgs-next]');
        const pagination = sectionRoot.querySelector('[data-pgs-pagination]');

        const spvM = parseFloat(el.dataset.spvM || 1);
        const spvT = parseFloat(el.dataset.spvT || 2);
        const spvD = parseFloat(el.dataset.spvD || 3);
        const gap = Number(el.dataset.gap || 16);
        const loop = toBool(el.dataset.loop);
        const autoplayEnabled = toBool(el.dataset.autoplay);
        const speed = Number(el.dataset.speed || 3000);
        const effect = el.dataset.effect || 'slide';
        const speedTransition = Number(el.dataset.speedTransition || 300);
        const centered = toBool(el.dataset.centered);
        const grab = toBool(el.dataset.grab);
        const freeMode = toBool(el.dataset.freeMode);
        const pauseOnHover = toBool(el.dataset.pauseOnHover);

        const cfg = {
          slidesPerView: spvM,
          spaceBetween: gap,
          watchOverflow: true,
          observer: true,
          observeParents: true,
          resizeObserver: true,
          speed: speedTransition,
          effect: effect,
          centeredSlides: centered,
          grabCursor: grab,
          freeMode: freeMode,
          loop: loop,
          breakpoints: {
            768: { slidesPerView: spvT, centeredSlides: centered, spaceBetween: gap },
            1024: { slidesPerView: spvD, centeredSlides: centered, spaceBetween: gap }
          }
        };

        if (prev && next) cfg.navigation = { prevEl: prev, nextEl: next };
        if (pagination) cfg.pagination = { el: pagination, clickable: true };
        if (autoplayEnabled) cfg.autoplay = { delay: speed, disableOnInteraction: false, pauseOnMouseEnter: pauseOnHover };

        if (effect === 'fade') cfg.fadeEffect = { crossFade: true };
        else if (effect === 'cube') cfg.cubeEffect = { shadow: true, slideShadows: true, shadowOffset: 20, shadowScale: 0.94 };
        else if (effect === 'coverflow') cfg.coverflowEffect = { rotate: 50, stretch: 0, depth: 100, modifier: 1, slideShadows: true };
        else if (effect === 'flip') cfg.flipEffect = { slideShadows: true, limitRotation: true };

        el.__pgsSwiper = new window.Swiper(el, cfg);

        [50, 200, 500].forEach(ms => {
          setTimeout(() => {
            if (el.__pgsSwiper) el.__pgsSwiper.update();
          }, ms);
        });

        return true;
      }

      function bootAll() {
        document.querySelectorAll('.product-grid-simple').forEach(root => {
          const el = root.querySelector('[data-pgs-swiper]');
          if (!el) return;
          let tries = 0;
          const t = setInterval(() => {
            tries++;
            if (initSwiper(root) || tries > 40) clearInterval(t);
          }, 100);
        });
      }

      bootAll();

      document.addEventListener('shopify:section:load', (e) => {
        const root = document.querySelector('.product-grid-simple-' + e.detail.sectionId);
        if (root) setTimeout(() => initSwiper(root), 150);
      });
      document.addEventListener('shopify:section:select', (e) => {
        const root = document.querySelector('.product-grid-simple-' + e.detail.sectionId);
        if (root) setTimeout(() => initSwiper(root), 150);
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-age-verifier"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var key = 'tw_age_verified';
    if (document.cookie.indexOf(key + '=1') !== -1) return;
    var el = document.querySelector('[data-tw-age-verifier]');
    if (!el) return;
    el.classList.remove('tw-hidden');
    el.setAttribute('aria-hidden', 'false');
    el.querySelector('[data-tw-age-approve]') && el.querySelector('[data-tw-age-approve]').addEventListener('click', function() {
      document.cookie = key + '=1; path=/; max-age=31536000';
      el.classList.add('tw-hidden');
      el.setAttribute('aria-hidden', 'true');
    });
    el.querySelector('[data-tw-age-decline]') && el.querySelector('[data-tw-age-decline]').addEventListener('click', function() {
      el.querySelector('.tw-age-verifier__content').classList.add('tw-hidden');
      el.querySelector('.tw-age-verifier__decline').classList.remove('tw-hidden');
    });
    el.querySelector('[data-tw-age-return]') && el.querySelector('[data-tw-age-return]').addEventListener('click', function() {
      el.querySelector('.tw-age-verifier__decline').classList.add('tw-hidden');
      el.querySelector('.tw-age-verifier__content').classList.remove('tw-hidden');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-cart-upsell"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.cart-upsell--fetch').forEach(function(el) {
      if (!el.dataset.url) return;
      var track = el.querySelector('[data-upsell-track]');
      if (!track) return;
      fetch(el.dataset.url)
        .then(function(r) { return r.ok ? r.text() : Promise.reject(); })
        .then(function(html) {
          var wrap = document.createElement('div');
          wrap.innerHTML = html;
          var sectionId = (el.dataset.sectionId || 'tw-cart-upsell').replace(/\W/g, '-');
          var remote = wrap.querySelector('#shopify-section-' + sectionId + ' [data-upsell-track]');
          if (!remote) remote = wrap.querySelector('[data-upsell-track]');
          if (remote && remote.children.length > 0) {
            track.innerHTML = remote.innerHTML;
          } else {
            el.style.display = 'none';
          }
        })
        .catch(function() { el.style.display = 'none'; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-collection-grid"] && !Shopify.designMode) return;
  try {
    
    (() => {
      const swiperEl = document.querySelector('[data-cg-swiper]');
      if (!swiperEl) return;
      const root = swiperEl.closest('section[data-section-id]');
      if (!root) return;
      const SECTION_ID = root.getAttribute('data-section-id');

      const toBool = (v) => String(v) === 'true' || String(v) === '1';

      const init = () => {
        if (!window.Swiper) return false;

        const prev = swiperEl.querySelector('[data-cg-prev]');
        const next = swiperEl.querySelector('[data-cg-next]');
        const pagination = swiperEl.querySelector('[data-cg-pagination]');

        const spvM = parseFloat(swiperEl.getAttribute('data-spv-m') || 1);
        const spvT = parseFloat(swiperEl.getAttribute('data-spv-t') || 2);
        const spvD = parseFloat(swiperEl.getAttribute('data-spv-d') || 3);
        const gap = Number(swiperEl.getAttribute('data-gap') || 16);

        const loop = toBool(swiperEl.getAttribute('data-loop'));
        const autoplayEnabled = toBool(swiperEl.getAttribute('data-autoplay'));
        const speed = Number(swiperEl.getAttribute('data-speed') || 3000);
        const effect = swiperEl.getAttribute('data-effect') || 'slide';
        const speedTransition = Number(swiperEl.getAttribute('data-speed-transition') || 300);
        const centered = toBool(swiperEl.getAttribute('data-centered'));
        const grab = toBool(swiperEl.getAttribute('data-grab'));
        const freeMode = toBool(swiperEl.getAttribute('data-free-mode'));
        const pauseOnHover = toBool(swiperEl.getAttribute('data-pause-on-hover'));

        if (swiperEl.__twSwiper) {
          try { swiperEl.__twSwiper.destroy(true, true); } catch(e) {}
          swiperEl.__twSwiper = null;
        }

        const cfg = {
          slidesPerView: spvM,
          spaceBetween: gap,
          watchOverflow: true,
          speed: speedTransition,
          effect: effect,
          centeredSlides: centered,
          grabCursor: grab,
          freeMode: freeMode,
          loop: loop,
          breakpoints: {
            768: { slidesPerView: spvT, centeredSlides: centered },
            1024: { slidesPerView: spvD, centeredSlides: centered }
          }
        };

        // Navigation
        if (prev && next) {
          cfg.navigation = { prevEl: prev, nextEl: next };
        }

        // Pagination
        if (pagination) {
          cfg.pagination = {
            el: pagination,
            clickable: true,
            dynamicBullets: false
          };
        }

        // Autoplay
        if (autoplayEnabled) {
          cfg.autoplay = {
            delay: speed,
            disableOnInteraction: false,
            pauseOnMouseEnter: pauseOnHover
          };
        }

        // Effect-specific settings
        if (effect === 'fade') {
          cfg.fadeEffect = { crossFade: true };
        } else if (effect === 'cube') {
          cfg.cubeEffect = {
            shadow: true,
            slideShadows: true,
            shadowOffset: 20,
            shadowScale: 0.94
          };
        } else if (effect === 'coverflow') {
          cfg.coverflowEffect = {
            rotate: 50,
            stretch: 0,
            depth: 100,
            modifier: 1,
            slideShadows: true
          };
        } else if (effect === 'flip') {
          cfg.flipEffect = {
            slideShadows: true,
            limitRotation: true
          };
        }

        swiperEl.__twSwiper = new window.Swiper(swiperEl, cfg);
        return true;
      };

      let tries = 0;
      const t = setInterval(() => {
        tries += 1;
        if (init() || tries > 40) clearInterval(t);
      }, 100);

      document.addEventListener('shopify:section:load', (e) => {
        if (e?.detail?.sectionId != SECTION_ID) return;
        setTimeout(init, 80);
      });
      document.addEventListener('shopify:section:select', (e) => {
        if (e?.detail?.sectionId != SECTION_ID) return;
        setTimeout(init, 80);
      });
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-libro-reclamaciones"] && !Shopify.designMode) return;
  try {
    
  function initLibroReclamacionesDate() {
    document.querySelectorAll('.lr-current-date').forEach(function (el) {
      var loc = el.getAttribute('data-locale') || 'es-ES';
      var dateOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
      var today = new Date().toLocaleDateString(loc, dateOptions);
      today = today.charAt(0).toUpperCase() + today.slice(1);
      today = today.replace(/,/g, '');
      el.textContent = today;
    });
  }
  document.addEventListener('DOMContentLoaded', initLibroReclamacionesDate);
  document.addEventListener('shopify:section:load', initLibroReclamacionesDate);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-main-article"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initArticleSwiper(root) {
      if (!root) return;
      var el = root.querySelector('[data-tw-article-swiper]');
      if (!el || typeof window.Swiper === 'undefined') return;
      if (el._twArticleSwiper) {
        try {
          el._twArticleSwiper.destroy(true, true);
        } catch (e) {}
        el._twArticleSwiper = null;
      }
      var prev = root.querySelector('[data-tw-article-prev]');
      var next = root.querySelector('[data-tw-article-next]');
      var pagination = root.querySelector('[data-tw-article-pagination]');
      var cfg = {
        slidesPerView: 1,
        spaceBetween: 16,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        breakpoints: {
          768: { slidesPerView: 2, spaceBetween: 20 },
          1024: { slidesPerView: 3, spaceBetween: 24 }
        }
      };
      if (prev && next) cfg.navigation = { prevEl: prev, nextEl: next };
      if (pagination) cfg.pagination = { el: pagination, clickable: true };
      el._twArticleSwiper = new window.Swiper(el, cfg);
      [80, 250, 500].forEach(function (ms) {
        setTimeout(function () {
          try {
            if (el._twArticleSwiper) el._twArticleSwiper.update();
          } catch (e) {}
        }, ms);
      });
    }
    function bootAll() {
      document.querySelectorAll('[data-tw-article-root]').forEach(function (root) {
        var tries = 0;
        var timer = setInterval(function () {
          tries++;
          if (typeof window.Swiper !== 'undefined') {
            initArticleSwiper(root);
            clearInterval(timer);
          } else if (tries > 50) clearInterval(timer);
        }, 100);
      });
    }
    function bootOne(sectionId) {
      var root = document.querySelector('[data-tw-article-root="' + sectionId + '"]');
      if (!root) return;
      var tries = 0;
      var timer = setInterval(function () {
        tries++;
        if (typeof window.Swiper !== 'undefined') {
          initArticleSwiper(root);
          clearInterval(timer);
        } else if (tries > 50) clearInterval(timer);
      }, 100);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bootAll);
    } else {
      bootAll();
    }
    document.addEventListener('shopify:section:load', function (e) {
      setTimeout(function () {
        bootOne(String(e.detail.sectionId));
      }, 120);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-main-collection"] && !Shopify.designMode) return;
  try {
    
  (function() {
    if (window.__twMainCollectionToolbar) return;
    window.__twMainCollectionToolbar = true;

    function collectionRoot(el) {
      return el && el.closest ? el.closest('[data-tw-collection-root]') : null;
    }

    function syncBodyScroll() {
      var open = document.querySelector('[data-tw-sidebar-overlay]:not(.tw-pointer-events-none)');
      document.documentElement.style.overflow = open ? 'hidden' : '';
    }

    function openDrawer(root) {
      var overlay = root.querySelector('[data-tw-sidebar-overlay]');
      var panel = root.querySelector('[data-tw-drawer-panel]');
      var btn = root.querySelector('[data-tw-sidebar-open]');
      if (overlay) {
        overlay.classList.remove('tw-pointer-events-none', 'tw-opacity-0');
        overlay.setAttribute('aria-hidden', 'false');
      }
      if (panel) panel.classList.remove('-tw-translate-x-full');
      if (btn) btn.setAttribute('aria-expanded', 'true');
      syncBodyScroll();
    }

    function closeDrawer(root) {
      var overlay = root.querySelector('[data-tw-sidebar-overlay]');
      var panel = root.querySelector('[data-tw-drawer-panel]');
      var btn = root.querySelector('[data-tw-sidebar-open]');
      if (overlay) {
        overlay.classList.add('tw-pointer-events-none', 'tw-opacity-0');
        overlay.setAttribute('aria-hidden', 'true');
      }
      if (panel) panel.classList.add('-tw-translate-x-full');
      if (btn) btn.setAttribute('aria-expanded', 'false');
      syncBodyScroll();
    }

    document.addEventListener('click', function(e) {
      var t = e.target;
      if (t.closest && t.closest('[data-tw-sidebar-open]')) {
        var openBtn = t.closest('[data-tw-sidebar-open]');
        var root = collectionRoot(openBtn);
        if (root) {
          e.preventDefault();
          openDrawer(root);
        }
        return;
      }
      if (t.closest && t.closest('[data-tw-sidebar-close]')) {
        var c = t.closest('[data-tw-sidebar-close]');
        var rootC = collectionRoot(c);
        if (rootC) {
          e.preventDefault();
          closeDrawer(rootC);
        }
        return;
      }
      if (t.closest && t.closest('[data-tw-sidebar-overlay]')) {
        var ov = t.closest('[data-tw-sidebar-overlay]');
        if (ov && !ov.classList.contains('tw-pointer-events-none')) {
          var rootO = collectionRoot(ov);
          if (rootO) closeDrawer(rootO);
        }
        return;
      }
      var layoutBtn = t.closest && t.closest('[data-tw-layout]');
      if (layoutBtn) {
        var rootV = collectionRoot(layoutBtn);
        if (!rootV || rootV.getAttribute('data-enable-view-toggle') !== 'true') return;
        var mode = layoutBtn.getAttribute('data-tw-layout');
        if (!mode) return;
        e.preventDefault();
        var sectionId = rootV.getAttribute('data-section-id');
        var storageKey = 'tw-collection-layout-' + sectionId;
        var defCols = parseInt(rootV.getAttribute('data-cols-desktop-default'), 10);
        if (isNaN(defCols) || defCols < 2) defCols = 4;
        if (mode === 'list') {
          rootV.classList.add('tw-main-collection--list');
        } else {
          rootV.classList.remove('tw-main-collection--list');
          var cols = defCols;
          if (mode === 'grid') {
            cols = defCols;
          } else if (mode === 'grid-2') {
            cols = 2;
          } else if (mode === 'grid-3') {
            cols = 3;
          } else if (mode === 'grid-4') {
            cols = 4;
          }
          rootV.style.setProperty('--mcp-cols-d', String(cols));
        }
        try {
          sessionStorage.setItem(storageKey, mode);
        } catch (err) {}
        syncLayoutButtons(rootV);
      }
    });

    document.addEventListener('change', function(e) {
      var sel = e.target;
      if (!sel.matches || !sel.matches('select[name="sort_by"]')) return;
      var form = sel.closest('.tw-main-collection__sort-form');
      if (form) form.submit();
    });

    document.addEventListener('keydown', function(e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('[data-tw-collection-root]').forEach(function(root) {
        var overlay = root.querySelector('[data-tw-sidebar-overlay]');
        if (overlay && !overlay.classList.contains('tw-pointer-events-none')) closeDrawer(root);
      });
    });

    function getDesktopCols(root) {
      var c = getComputedStyle(root).getPropertyValue('--mcp-cols-d');
      var n = parseInt(String(c).trim(), 10);
      if (!isNaN(n) && n >= 2) return n;
      var d = parseInt(root.getAttribute('data-cols-desktop-default'), 10);
      return !isNaN(d) && d >= 2 ? d : 4;
    }

    function syncLayoutButtons(root) {
      var listMode = root.classList.contains('tw-main-collection--list');
      var cols = getDesktopCols(root);
      root.querySelectorAll('[data-tw-layout]').forEach(function(btn) {
        var m = btn.getAttribute('data-tw-layout');
        var on = false;
        if (listMode) {
          on = m === 'list';
        } else if (m === 'list') {
          on = false;
        } else if (m === 'grid') {
          on = true;
        } else if (m === 'grid-2') {
          on = cols === 2;
        } else if (m === 'grid-3') {
          on = cols === 3;
        } else if (m === 'grid-4') {
          on = cols >= 4;
        }
        btn.classList.toggle('tw-collection-view-btn--active', on);
        btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    }

    function restoreCollectionLayouts() {
      document.querySelectorAll('[data-tw-collection-root][data-enable-view-toggle="true"]').forEach(function(root) {
        var sectionId = root.getAttribute('data-section-id');
        var storageKey = 'tw-collection-layout-' + sectionId;
        var legacyKey = 'tw-collection-view-' + sectionId;
        var saved = null;
        try {
          saved = sessionStorage.getItem(storageKey);
          if (!saved) saved = sessionStorage.getItem(legacyKey);
        } catch (err) {}
        if (!saved) {
          syncLayoutButtons(root);
          return;
        }
        var defCols = parseInt(root.getAttribute('data-cols-desktop-default'), 10);
        if (isNaN(defCols) || defCols < 2) defCols = 4;
        if (saved === 'list') {
          root.classList.add('tw-main-collection--list');
        } else {
          root.classList.remove('tw-main-collection--list');
          if (saved === 'grid') {
            root.style.setProperty('--mcp-cols-d', String(defCols));
          } else if (saved.indexOf('grid-') === 0) {
            var n = parseInt(saved.slice(5), 10);
            if (!isNaN(n) && n >= 2 && n <= 6) {
              root.style.setProperty('--mcp-cols-d', String(n));
            }
          }
        }
        syncLayoutButtons(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', restoreCollectionLayouts);
    } else {
      restoreCollectionLayouts();
    }
    document.addEventListener('shopify:section:load', restoreCollectionLayouts);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-main-product"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll('section[id^="tw-main-product-"]');
    if (!sections.length) { console.log('[TW Sticky] No tw-main-product section found'); return; }
    sections.forEach(function(sectionEl) {
      var sectionId = sectionEl.getAttribute('data-section-id') || sectionEl.id.replace('tw-main-product-', '');
      if (!sectionId) return;
      var form = document.getElementById('product-form-' + sectionId);
      if (!form) return;
    const productJson = sectionEl.querySelector('[data-product-json]');
    const variantPricesJson = sectionEl.querySelector('[data-variant-prices]');
    const product = productJson ? JSON.parse(productJson.textContent) : null;
    const variantPrices = variantPricesJson ? JSON.parse(variantPricesJson.textContent) : {};
    if (!product) return;

    const hiddenId = form.querySelector('input[name="id"]');
    const priceEl = document.getElementById('price-' + sectionId);
    const submitBtn = sectionEl.querySelector('.tw-pdp-buy-buttons__add') || sectionEl.querySelector('button[type="submit"][name="add"]');
    const addToCartLabel = submitBtn && submitBtn.getAttribute('data-add-to-cart');
    const soldOutLabel = submitBtn && submitBtn.getAttribute('data-sold-out');
    const variantOptions = sectionEl.querySelectorAll('.tw-variant-option');

    function getSelectedOptions() {
      const byPosition = {};
      variantOptions.forEach(function(el) {
        const pos = parseInt(el.getAttribute('data-option-position'), 10) || 0;
        if (!byPosition[pos]) byPosition[pos] = [];
        byPosition[pos].push(el);
      });
      const positions = Object.keys(byPosition).map(Number).sort(function(a, b) { return a - b; });
      const opts = [];
      positions.forEach(function(pos) {
        const els = byPosition[pos];
        let val = null;
        els.forEach(function(el) {
          if (el.tagName === 'SELECT') val = el.value || null;
          else if (el.checked) val = el.value || null;
        });
        opts.push(val);
      });
      return opts;
    }

    function findVariant(opts) {
      for (let i = 0; i < product.variants.length; i++) {
        const v = product.variants[i];
        if (v.option1 === (opts[0] || null) && v.option2 === (opts[1] || null) && v.option3 === (opts[2] || null)) {
          return v;
        }
      }
      return null;
    }

    function updateForm(variant) {
      if (!variant) return;
      hiddenId.value = variant.id;

      if (variant.featured_media && variant.featured_media.position) {
        const mediaGallery = document.querySelector('#tw-gallery-tw-main-product-' + sectionId);
        if (mediaGallery && typeof mediaGallery.goToSlide === 'function') {
          mediaGallery.goToSlide(variant.featured_media.position - 1);
        }
      }
      if (priceEl && variantPrices[variant.id]) {
        const prices = variantPrices[variant.id];
        const priceSpan = priceEl.querySelector('.tw-product-price');
        if (priceSpan) priceSpan.textContent = prices.price;
        const compare = priceEl.querySelector('.tw-line-through');
        if (compare) {
          if (variant.compare_at_price > variant.price && prices.compare_at_price) {
            compare.textContent = prices.compare_at_price;
            compare.style.display = '';
          } else {
            compare.style.display = 'none';
          }
        }
      }
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available ? (addToCartLabel || 'Add to cart') : (soldOutLabel || 'Sold out');
      }
      sectionEl.querySelectorAll('.tw-pdp-buy-buttons__add').forEach(function(btn) {
        if (btn === submitBtn) return;
        btn.disabled = !variant.available;
        btn.textContent = variant.available ? (btn.getAttribute('data-add-to-cart') || 'Add to cart') : (btn.getAttribute('data-sold-out') || 'Sold out');
      });
      const stickyPrices = sectionEl.querySelectorAll('[data-sticky-price]');
      const stickyAdd = sectionEl.querySelector('#tw-sticky-bar-add-' + sectionId);
      const stickyVariantSelect = sectionEl.querySelector('.tw-sticky-bar-variant');
      if (variantPrices[variant.id]) {
        stickyPrices.forEach(function(el) {
          el.textContent = variantPrices[variant.id].price;
        });
      }
      if (stickyAdd) {
        stickyAdd.disabled = !variant.available;
        var stickyTxt = variant.available ? (stickyAdd.getAttribute('data-add-to-cart') || 'Add to cart') : (stickyAdd.getAttribute('data-sold-out') || 'Sold out');
        var stickyLabel = stickyAdd.querySelector('.tw-sticky-bar-add__text');
        if (stickyLabel) stickyLabel.textContent = stickyTxt;
        else stickyAdd.textContent = stickyTxt;
      }
      if (stickyVariantSelect) stickyVariantSelect.value = String(variant.id);
      var dynamicCheckout = sectionEl.querySelector('[data-dynamic-checkout-wrapper]');
      if (dynamicCheckout) dynamicCheckout.style.display = variant.available ? '' : 'none';
    }

    function syncStickyQuantityFromForm() {
      const mainQty = form.querySelector('input[name="quantity"]');
      const stickyQty = sectionEl.querySelector('.tw-sticky-bar-quantity');
      if (mainQty && stickyQty) stickyQty.value = mainQty.value;
    }
    function syncFormQuantityFromSticky() {
      const mainQty = form.querySelector('input[name="quantity"]');
      const stickyQty = sectionEl.querySelector('.tw-sticky-bar-quantity');
      if (mainQty && stickyQty) mainQty.value = stickyQty.value;
    }

    const triggerEl = sectionEl.querySelector('.tw-buy-buttons-trigger');
    const stickyBar = sectionEl.querySelector('.tw-sticky-add-cart');
    if (triggerEl && stickyBar) {
      syncStickyQuantityFromForm();
      const stickyVariantSelect = sectionEl.querySelector('.tw-sticky-bar-variant');
      if (stickyVariantSelect) {
        stickyVariantSelect.addEventListener('change', function() {
          const vid = parseInt(this.value, 10);
          const v = product.variants.find(function(x) { return x.id === vid; });
          if (v) updateForm(v);
        });
      }
      const stickyQty = sectionEl.querySelector('.tw-sticky-bar-quantity');
      if (stickyQty) {
        stickyQty.addEventListener('change', syncFormQuantityFromSticky);
        stickyQty.addEventListener('input', syncFormQuantityFromSticky);
        sectionEl.querySelectorAll('.tw-sticky-qty-minus, .tw-sticky-qty-plus').forEach(function(btn) {
          btn.addEventListener('click', function() {
            var n = parseInt(stickyQty.value, 10) || 1;
            if (btn.classList.contains('tw-sticky-qty-minus')) n = Math.max(1, n - 1);
            else n = Math.min(99, n + 1);
            stickyQty.value = n;
            syncFormQuantityFromSticky();
          });
        });
      }
      const mainQtyInput = form.querySelector('input[name="quantity"]');
      if (mainQtyInput) {
        mainQtyInput.addEventListener('change', syncStickyQuantityFromForm);
        mainQtyInput.addEventListener('input', syncStickyQuantityFromForm);
      }
      form.addEventListener('click', function(e) {
        if (e.target.closest('[data-qty-minus], [data-qty-plus]')) setTimeout(syncStickyQuantityFromForm, 0);
      });

      let stickyVisible = false;
      /* Solo el pie global (sections/footer.liquid). querySelector('footer') cogía el primero del DOM (p. ej. testimonios) y rompía el scroll/hide en desktop. */
      const footerEl = document.querySelector('footer.tw-footer');
      var stickyBarHeight = 80;
      function onScroll() {
        const triggerRect = triggerEl.getBoundingClientRect();
        const viewportHeight = window.innerHeight;
        var footerNear = false;
        if (footerEl) {
          var footerRect = footerEl.getBoundingClientRect();
          footerNear = footerRect.top < viewportHeight - stickyBarHeight;
        }
        if (footerNear) {
          if (stickyVisible) { stickyBar.classList.remove('tw-translate-y-0'); stickyBar.classList.add('tw-translate-y-full'); stickyBar.setAttribute('aria-hidden', 'true'); stickyVisible = false; }
          return;
        }
        if (triggerRect.bottom <= 0) {
          if (!stickyVisible) { stickyBar.classList.add('tw-translate-y-0'); stickyBar.classList.remove('tw-translate-y-full'); stickyBar.setAttribute('aria-hidden', 'false'); stickyVisible = true; }
        } else {
          if (stickyVisible) { stickyBar.classList.remove('tw-translate-y-0'); stickyBar.classList.add('tw-translate-y-full'); stickyBar.setAttribute('aria-hidden', 'true'); stickyVisible = false; }
        }
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
      const stickyAddBtn = sectionEl.querySelector('.tw-sticky-bar-add');
      if (stickyAddBtn) {
        stickyAddBtn.addEventListener('click', function() {
          if (form && !stickyAddBtn.disabled) form.requestSubmit();
        });
      }
    }

    variantOptions.forEach(function(el) {
      el.addEventListener('change', function() {
        const opts = getSelectedOptions();
        const variant = findVariant(opts);
        updateForm(variant);
      });
    });
    var currentVariantId = hiddenId && parseInt(hiddenId.value, 10);
    if (currentVariantId && product && product.variants) {
      var currentVariant = product.variants.find(function(v) { return v.id === currentVariantId; });
      if (currentVariant) updateForm(currentVariant);
    }
    }); // end sections.forEach
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-media-gallery-slide"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-tw-mgs]');
    if (!section || !section.querySelector('[data-tw-mgs-list]')) return;
    var list = section.querySelector('[data-tw-mgs-list]');
    var slides = section.querySelectorAll('[data-tw-mgs-slide]');
    var total = slides.length;
    if (total <= 0) return;
    var index = 0;
    var autoplay = section.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(section.getAttribute('data-speed'), 10) || 5000;
    var timer = null;
    function goTo(i) {
      index = (i + total) % total;
      list.style.transform = 'translateX(-' + (index * 100) + '%)';
    }
    function next() { goTo(index + 1); }
    section.querySelector('[data-tw-mgs-prev]') && section.querySelector('[data-tw-mgs-prev]').addEventListener('click', function() { goTo(index - 1); if (timer) clearInterval(timer); if (autoplay) timer = setInterval(next, speed); });
    section.querySelector('[data-tw-mgs-next]') && section.querySelector('[data-tw-mgs-next]').addEventListener('click', function() { goTo(index + 1); if (timer) clearInterval(timer); if (autoplay) timer = setInterval(next, speed); });
    goTo(0);
    if (autoplay && total > 1) timer = setInterval(next, speed);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-minicart-form"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.tw-cart-upsell--fetch').forEach(function(el) {
      if (!el.dataset.url) return;
      var grid = el.querySelector('.tw-cart-upsell__grid');
      if (!grid) return;
      fetch(el.dataset.url)
        .then(function(r) { return r.ok ? r.text() : Promise.reject(); })
        .then(function(html) {
          var wrap = document.createElement('div');
          wrap.innerHTML = html;
          var sectionId = (el.dataset.sectionId || 'tw-cart-upsell').replace(/\W/g, '-');
          var sectionEl = wrap.querySelector('#shopify-section-' + sectionId + ' .tw-cart-upsell__grid');
          if (!sectionEl && wrap.querySelector('.tw-cart-upsell__grid')) sectionEl = wrap.querySelector('.tw-cart-upsell__grid');
          if (sectionEl && sectionEl.innerHTML.trim()) {
            grid.innerHTML = sectionEl.innerHTML;
            grid.classList.remove('tw-cart-upsell__grid--placeholder');
          } else {
            el.style.display = 'none';
          }
        })
        .catch(function() { el.style.display = 'none'; });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-pickup-availability"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const section = document.querySelector('[data-tw-pickup-drawer]') && document.querySelector('[data-tw-pickup-drawer]').closest('.tw-pickup-availability');
    if (!section) return;
    const trigger = section.querySelector('[data-tw-pickup-trigger]');
    const drawer = section.querySelector('[data-tw-pickup-drawer]');
    const closeBtns = section.querySelectorAll('[data-tw-pickup-close]');
    function open() {
      if (drawer) drawer.classList.remove('tw-hidden');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }
    function close() {
      if (drawer) drawer.classList.add('tw-hidden');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }
    if (trigger) trigger.addEventListener('click', open);
    closeBtns.forEach(function(btn) { btn.addEventListener('click', close); });
    if (drawer) drawer.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') close();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-related-products"] && !Shopify.designMode) return;
  try {
    
    (() => {
      const toBool = (v) => String(v) === 'true' || String(v) === '1';

      function initPgsSwiper(sectionRoot) {
        const el = sectionRoot.querySelector('[data-pgs-swiper]');
        if (!el || !window.Swiper) return false;

        if (el.__pgsSwiper) {
          try { el.__pgsSwiper.destroy(true, true); } catch(e) {}
          el.__pgsSwiper = null;
        }

        const prev = sectionRoot.querySelector('[data-pgs-prev]');
        const next = sectionRoot.querySelector('[data-pgs-next]');
        const pagination = sectionRoot.querySelector('[data-pgs-pagination]');

        const spvM = parseFloat(el.dataset.spvM || 1);
        const spvT = parseFloat(el.dataset.spvT || 2);
        const spvD = parseFloat(el.dataset.spvD || 3);
        const gap = Number(el.dataset.gap || 16);
        const loop = toBool(el.dataset.loop);
        const autoplayEnabled = toBool(el.dataset.autoplay);
        const speed = Number(el.dataset.speed || 3000);
        const effect = el.dataset.effect || 'slide';
        const speedTransition = Number(el.dataset.speedTransition || 300);
        const centered = toBool(el.dataset.centered);
        const grab = toBool(el.dataset.grab);
        const freeMode = toBool(el.dataset.freeMode);
        const pauseOnHover = toBool(el.dataset.pauseOnHover);

        const cfg = {
          slidesPerView: spvM,
          spaceBetween: gap,
          watchOverflow: true,
          observer: true,
          observeParents: true,
          resizeObserver: true,
          speed: speedTransition,
          effect: effect,
          centeredSlides: centered,
          grabCursor: grab,
          freeMode: freeMode,
          loop: loop,
          breakpoints: {
            768: { slidesPerView: spvT, centeredSlides: centered, spaceBetween: gap },
            1024: { slidesPerView: spvD, centeredSlides: centered, spaceBetween: gap }
          }
        };

        if (prev && next) cfg.navigation = { prevEl: prev, nextEl: next };
        if (pagination) cfg.pagination = { el: pagination, clickable: true };
        if (autoplayEnabled) cfg.autoplay = { delay: speed, disableOnInteraction: false, pauseOnMouseEnter: pauseOnHover };

        if (effect === 'fade') cfg.fadeEffect = { crossFade: true };
        else if (effect === 'cube') cfg.cubeEffect = { shadow: true, slideShadows: true, shadowOffset: 20, shadowScale: 0.94 };
        else if (effect === 'coverflow') cfg.coverflowEffect = { rotate: 50, stretch: 0, depth: 100, modifier: 1, slideShadows: true };
        else if (effect === 'flip') cfg.flipEffect = { slideShadows: true, limitRotation: true };

        el.__pgsSwiper = new window.Swiper(el, cfg);

        [50, 200, 500].forEach(ms => {
          setTimeout(() => {
            if (el.__pgsSwiper) el.__pgsSwiper.update();
          }, ms);
        });

        return true;
      }

      function bootRelatedRoots() {
        document.querySelectorAll('.product-grid-simple--related').forEach(root => {
          const el = root.querySelector('[data-pgs-swiper]');
          if (!el) return;
          let tries = 0;
          const t = setInterval(() => {
            tries++;
            if (initPgsSwiper(root) || tries > 40) clearInterval(t);
          }, 100);
        });
      }

      bootRelatedRoots();

      document.addEventListener('shopify:section:load', (e) => {
        const root = document.querySelector('.product-grid-simple-' + e.detail.sectionId + '.product-grid-simple--related');
        if (root) setTimeout(() => initPgsSwiper(root), 150);
      });
      document.addEventListener('shopify:section:select', (e) => {
        const root = document.querySelector('.product-grid-simple-' + e.detail.sectionId + '.product-grid-simple--related');
        if (root) setTimeout(() => initPgsSwiper(root), 150);
      });

      if (!window.customElements || !window.customElements.get('tw-product-recommendations')) {
        function parseRecommendationsFromHtml(html) {
          try {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            var rec = doc.querySelector('tw-product-recommendations');
            if (!rec) {
              var shopSec = doc.querySelector('.shopify-section');
              if (shopSec) rec = shopSec.querySelector('tw-product-recommendations');
            }
            return rec;
          } catch (e) {
            return null;
          }
        }

        function recommendationsHasProductCards(recEl) {
          if (!recEl) return false;
          return !!(recEl.querySelector('.tw-pc') || recEl.querySelector('article.tw-pc'));
        }

        class TwProductRecommendations extends HTMLElement {
          connectedCallback() {
            if (this._observed) return;
            this._observed = true;
            const url = this.getAttribute('data-url');
            if (!url) return;
            const sectionRoot = this.closest('section');

            const applyResponse = function(html) {
              const rec = parseRecommendationsFromHtml(html);
              if (!rec) {
                console.warn('Product recommendations: could not parse section response');
                return;
              }

              var hasCards = recommendationsHasProductCards(rec);
              if (hasCards || rec.innerHTML.trim()) {
                this.innerHTML = rec.innerHTML;
                if (sectionRoot && sectionRoot.querySelector('[data-pgs-swiper]')) {
                  var tries = 0;
                  var t = setInterval(function() {
                    tries++;
                    if (initPgsSwiper(sectionRoot) || tries > 50) clearInterval(t);
                  }, 100);
                }
              }
            }.bind(this);

            const runFetch = function() {
              fetch(url)
                .then(function(r) {
                  if (!r.ok) throw new Error('HTTP ' + r.status);
                  return r.text();
                })
                .then(applyResponse)
                .catch(function(e) {
                  console.error('Product recommendations:', e);
                });
            }.bind(this);

            if (window.Shopify && window.Shopify.designMode) {
              runFetch();
              return;
            }

            const observer = new IntersectionObserver(function(entries) {
              if (!entries[0].isIntersecting) return;
              observer.unobserve(this);
              runFetch();
            }.bind(this), { rootMargin: '0px 0px 400px 0px' });
            observer.observe(this);
          }
        }
        window.customElements.define('tw-product-recommendations', TwProductRecommendations);
      }
    })();
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-slideshow-banner"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var wrap = document.querySelector('[data-tw-sb]');
    if (!wrap || !wrap.querySelector('[data-tw-sb-list]')) return;
    var list = wrap.querySelector('[data-tw-sb-list]');
    var slides = wrap.querySelectorAll('[data-tw-sb-slide]');
    var n = slides.length;
    if (n <= 0) return;
    var idx = 0;
    var autoplay = wrap.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(wrap.getAttribute('data-speed'), 10) || 5000;
    var t = null;
    function go(i) {
      idx = (i + n) % n;
      list.style.transform = 'translateX(-' + (idx * 100) + '%)';
    }
    function next() { go(idx + 1); }
    if (wrap.querySelector('[data-tw-sb-prev]')) wrap.querySelector('[data-tw-sb-prev]').addEventListener('click', function() { go(idx - 1); if (t) clearInterval(t); if (autoplay) t = setInterval(next, speed); });
    if (wrap.querySelector('[data-tw-sb-next]')) wrap.querySelector('[data-tw-sb-next]').addEventListener('click', function() { go(idx + 1); if (t) clearInterval(t); if (autoplay) t = setInterval(next, speed); });
    go(0);
    if (autoplay && n > 1) t = setInterval(next, speed);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('[data-tw-slideshow]');
    if (!section || !section.querySelector('[data-tw-slideshow-list]')) return;
    var list = section.querySelector('[data-tw-slideshow-list]');
    var slides = section.querySelectorAll('[data-tw-slide]');
    var total = slides.length;
    if (total <= 0) return;
    var index = 0;
    var autoplay = section.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(section.getAttribute('data-speed'), 10) || 5000;
    var timer = null;
    function goTo(i) {
      index = (i + total) % total;
      list.style.transform = 'translateX(-' + (index * 100) + '%)';
      section.querySelectorAll('[data-tw-dot]').forEach(function(btn, j) {
        btn.setAttribute('aria-current', j === index ? 'slide' : null);
      });
    }
    function next() { goTo(index + 1); }
    function startAutoplay() {
      if (timer) clearInterval(timer);
      if (autoplay && total > 1) timer = setInterval(next, speed);
    }
    section.querySelector('[data-tw-slide-prev]') && section.querySelector('[data-tw-slide-prev]').addEventListener('click', function() { goTo(index - 1); startAutoplay(); });
    section.querySelector('[data-tw-slide-next]') && section.querySelector('[data-tw-slide-next]').addEventListener('click', function() { goTo(index + 1); startAutoplay(); });
    section.querySelectorAll('[data-tw-dot]').forEach(function(btn, i) {
      btn.addEventListener('click', function() { goTo(i); startAutoplay(); });
    });
    goTo(0);
    startAutoplay();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tw-usp"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function slideStep(viewport) {
      var grid = viewport.querySelector('[data-tw-usp-grid]');
      if (!grid) return viewport.clientWidth * 0.45;
      var slide = grid.querySelector('[data-tw-usp-slide]');
      if (!slide) return viewport.clientWidth * 0.45;
      var gap = parseFloat(getComputedStyle(grid).columnGap || getComputedStyle(grid).gap) || 0;
      return slide.getBoundingClientRect().width + gap;
    }

    function activeIndex(viewport, slides) {
      if (!slides.length) return 0;
      var left = viewport.scrollLeft;
      var step = slideStep(viewport);
      var idx = Math.round(left / step);
      if (idx < 0) idx = 0;
      if (idx >= slides.length) idx = slides.length - 1;
      return idx;
    }

    function updateDots(root, viewport, slides) {
      var dots = root.querySelectorAll('[data-tw-usp-dot]');
      if (!dots.length) return;
      var i = activeIndex(viewport, slides);
      for (var d = 0; d < dots.length; d++) {
        dots[d].setAttribute('aria-selected', d === i ? 'true' : 'false');
      }
    }

    function initTwUsp(root) {
      var carousel = root.querySelector('[data-tw-usp-carousel]');
      if (!carousel) return;
      var viewport = root.querySelector('[data-tw-usp-viewport]');
      var prev = root.querySelector('[data-tw-usp-prev]');
      var next = root.querySelector('[data-tw-usp-next]');
      if (!viewport || !prev || !next) return;

      var slides = viewport.querySelectorAll('[data-tw-usp-slide]');
      if (slides.length === 0) return;

      function scrollByDir(dir) {
        var delta = slideStep(viewport) * dir;
        viewport.scrollBy({ left: delta, behavior: 'smooth' });
      }

      prev.addEventListener('click', function () {
        scrollByDir(-1);
      });
      next.addEventListener('click', function () {
        scrollByDir(1);
      });

      root.querySelectorAll('[data-tw-usp-dot]').forEach(function (dot) {
        dot.addEventListener('click', function () {
          var idx = parseInt(dot.getAttribute('data-index'), 10);
          if (isNaN(idx)) return;
          var step = slideStep(viewport);
          viewport.scrollTo({ left: idx * step, behavior: 'smooth' });
        });
      });

      var scrollTimer;
      viewport.addEventListener(
        'scroll',
        function () {
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(function () {
            updateDots(root, viewport, slides);
          }, 50);
        },
        { passive: true }
      );

      updateDots(root, viewport, slides);
    }

    function initAll() {
      document.querySelectorAll('[data-tw-usp-root]').forEach(initTwUsp);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      if (!event.target || !event.target.querySelector) return;
      var root = event.target.querySelector('[data-tw-usp-root]');
      if (root) initTwUsp(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
